import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Menu, Button } from 'semantic-ui-react';
import Image from '../../atoms/Image';

import Embed from '../../atoms/Embed';
import './MenuFilesDisplay.css';

export default class MenuFilesDisplay extends React.Component {
  getTabPanes() {
    const { files } = this.props;

    return files.map(({ url, filename }, index) => ({
      menuItem: (
        <Menu.Item>
          <h3>{filename || `Menu ${index + 1}`}</h3>
        </Menu.Item>
      ),
      pane: (
        <Tab.Pane>
          {!url.includes('.pdf') && <Image src={url} fluid />}
          {url.includes('.pdf') && (
            <React.Fragment>
              <div className="desktop">
                <Embed url={url} active />
              </div>
              <div className="mobile">
                <Button as="a" href={url} target="_blank" primary className="mobile">
                  View {filename || `Menu ${index + 1}`}
                </Button>
              </div>
            </React.Fragment>
          )}
        </Tab.Pane>
      ),
    }));
  }

  render() {
    return (
      <Tab
        className="fm-menu-files-display"
        renderActiveOnly={false}
        menu={{
          style: { height: 'unset', overflowX: 'auto' },
          attached: true,
          tabular: true,
        }}
        panes={this.getTabPanes()}
      />
    );
  }
}

MenuFilesDisplay.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      filename: PropTypes.string,
    }),
  ).isRequired,
};

MenuFilesDisplay.defaultProps = {};
